{
  "card": {
    "title": "Ressurser",
    "description": "Oversikt over entreprenørens maskiner og skoglag"
  },
  "machines": {
    "addMachine": "Legg til maskin",
    "inactiveMachinePrefix": "(G)",
    "pagination": {
      "rowsPerPage": "Rader per side"
    },
    "remarkDialog": {
      "title": "Merknad",
      "close": "Lukk",
      "edit": "Endre maskin"
    },
    "setStatusDialog": {
      "activate": {
        "title": "Sett maskin {{machineId}} som aktiv?",
        "description": "Maskinen vil bli merket som aktiv og tilgjengelig for oppdrag.",
        "cancel": "Avbryt",
        "action": "Sett aktiv"
      },
      "deactivate": {
        "title": "Sett maskin {{machineId}} som inaktiv?",
        "description": "Maskinen vil bli merket som inaktiv.",
        "cancel": "Avbryt",
        "action": "Sett inaktiv"
      },
      "blocked": {
        "title": "Kan ikke endre status for maskin {{machineId}}",
        "description": "Maskinen er i et aktivt oppdrag og kan ikke endres.",
        "ok": "Lukk"
      },
      "errorTitle": "Kunne ikke endre status",
      "error": "Det oppstod en feil under oppdatering av maskinens status. Prøv igjen."
    },
    "deleteDialog": {
      "confirm": {
        "title": "Er du sikker på at du vil slette maskin {{machineId}}?",
        "description": "Denne handlingen kan ikke angres. Maskinen slettes permanent.",
        "cancel": "Avbryt",
        "action": "Slett maskin"
      },
      "blocked": {
        "title": "Kan ikke slette maskin {{machineId}}",
        "description": "Maskinen er i et aktivt oppdrag og kan ikke slettes før oppdraget er fullført.",
        "ok": "Lukk"
      },
      "errorTitle": "Kunne ikke slette maskin",
      "error": "Det oppstod en feil under sletting av maskinen. Prøv igjen."
    },
    "statusFilter": {
      "ariaLabel": "Filtrer maskiner etter status",
      "all": "Vis alle maskiner",
      "active": "Aktive maskiner",
      "inactive": "Inaktive maskiner"
    },
    "table": {
      "ariaLabel": "Maskiner",
      "columns": {
        "machineId": "ID",
        "remark": "Merknad",
        "machineName": "Maskinnavn",
        "type": "Type",
        "drivers": "Sjåfør",
        "brand": "Merke",
        "manufacturingYear": "Årsmodell",
        "buckingSystem": "Aptering",
        "actions": "Handlinger",
        "deactivated": "Deaktivert"
      },
      "deactivatedBadge": "Deaktivert",
      "remarkAriaLabel": "Vis merknad for maskin {{machineName}}",
      "actionsAriaLabel": "Flere handlinger for {{machineName}}",
      "noDriver": "Mangler sjåfør",
      "missingDriverIconAlt": "Maskinen mangler sjåfør"
    },
    "contextMenu": {
      "edit": "Endre maskin",
      "setInactive": "Deaktiver maskin",
      "setActive": "Gjenopprett maskin",
      "delete": "Slett maskin"
    },
    "emptyStateAllTitle": "Ingen maskiner registrert på denne entreprenøren",
    "emptyStateAllDescription": "Trykk på \"Legg til maskin\" for å starte registrering",
    "emptyStateActiveTitle": "Ingen aktive maskiner",
    "emptyStateActiveDescription": "Det er ingen aktive maskiner registrert på denne entreprenøren",
    "emptyStateInactiveTitle": "Ingen inaktive maskiner",
    "emptyStateInactiveDescription": "Det er ingen inaktive maskiner registrert på denne entreprenøren",
    "error": {
      "title": "Kunne ikke laste maskiner",
      "description": "Det oppstod en feil under henting av maskiner. Prøv igjen.",
      "retry": "Prøv igjen"
    }
  }
}
